import { fetchFinance, getOnlinePay, fetchOnlinePay } from "utils/api";

export const queryPayment = async (params) => {
  return await getOnlinePay("/payment/list", {
    page: 0,
    size: 20,
    sort: "created,desc",
    ...params,
  });
};

export const getLineItems = async (params) => {
  return await getOnlinePay("/payment/get-line-item", {
    ...params,
  });
};

export const queryTransaction = async (params) => {
  return await getOnlinePay("/transaction/list", {
    page: 0,
    size: 20,
    sort: "time,desc",
    ...params,
  });
};

export const voidTransactionForm = async (params) => {
  return await fetchOnlinePay("/transaction/action", {
    transactionType: "VOID",
    ...params,
  });
};

export const getTransactionRefundable = async (params) => {
  return await fetchFinance("/action", {
    method: "post",
    action: "getRefundable",
    ...params,
  });
};

export const refundTransaction = async (params) => {
  return await fetchOnlinePay("/transaction/action", {
    transactionType: "REFUND",
    ...params,
  });
};
